import { createSlice } from '@reduxjs/toolkit';
import { BulkEditResponseProps } from 'components/modals/bulkEditModals/UpdateFailed/updateFailed.types';

import { apiSlice } from '../api/apiSlice';
import {
  initialState,
  ReviewResponseProps,
  ReviewsProps,
  ReviewsQueryParams
} from './reviews.types';

const reviewsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getReview: build.query<ReviewResponseProps, { id: string; params: ReviewsQueryParams }>({
      providesTags: (_result, _error, arg) => [{ id: arg.id, type: 'Reviews' }],
      query: ({ id, params }) => ({ params, url: `/admin/reviews/${id}` }),
      transformResponse: (response: ReviewResponseProps) => ({
        data: response.data,
        info: response.info
      })
    }),
    getReviews: build.query<ReviewsProps, { params: ReviewsQueryParams }>({
      providesTags: (result) =>
        result
          ? ['Reviews', ...result.data.map(({ _id }) => ({ id: _id, type: 'Reviews' as const }))]
          : ['Reviews'],
      query: ({ params }) => ({ params, url: `/admin/reviews` }),
      transformResponse: (response: ReviewsProps) => ({
        data: response.data,
        info: response.info
      })
    }),
    moderateReviews: build.mutation({
      invalidatesTags: ['Reviews'],
      query: (body) => ({
        body,
        method: 'PATCH',
        url: `/admin/reviews/moderate`
      }),
      transformResponse: (response: BulkEditResponseProps) => response
    })
  })
});

export const { useGetReviewsQuery, useModerateReviewsMutation } = reviewsApi;

const reviewsSlice = createSlice({
  extraReducers: (builder) => {
    builder.addMatcher(reviewsApi.endpoints.getReviews.matchFulfilled, (state, action) => {
      if (action.payload) {
        state.data = action.payload.data;
        state.info = action.payload.info;
      }
    });
  },
  initialState: initialState,
  name: 'reviews',
  reducers: {
    resetReviews: () => initialState
  }
});

export default reviewsSlice.reducer;

export const { resetReviews } = reviewsSlice.actions;
